import { render, staticRenderFns } from "./TipoObrasEditar.vue?vue&type=template&id=2319118a&scoped=true&"
import script from "./TipoObrasEditar.vue?vue&type=script&lang=js&"
export * from "./TipoObrasEditar.vue?vue&type=script&lang=js&"
import style0 from "./TipoObrasEditar.vue?vue&type=style&index=0&id=2319118a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319118a",
  null
  
)

export default component.exports